var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9808C7A7-BF28-49A8-BBB2-A875CDDF3FB3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(-686.000000, -3977.000000)",
    fill: "#15AAC5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(300.000000, 3540.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(0.000000, 108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(386.000000, 326.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9784,15.284 L19.9784,20.7624 L3.2208,20.7624 L3.2208,15.284 L1.24344979e-14,15.284 L1.24344979e-14,22.3728 C1.24344979e-14,23.2616 0.72,23.9824 1.6128,23.9824 L21.5864,23.9824 C22.4784,23.9824 23.1992,23.2624 23.1992,22.3728 L23.1992,15.284 L19.9784,15.284 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3048,14.7408 L6.6936,9.1688 C6.6936,9.1688 5.992,8.5064 6.7528,8.5064 C7.5136,8.5064 9.3512,8.5064 9.3512,8.5064 C9.3512,8.5064 9.3512,8.0608 9.3512,7.3736 C9.3512,5.4144 9.3512,1.8488 9.3512,0.3952 C9.3512,0.3952 9.248,3.60600438e-13 9.8432,3.60600438e-13 C10.4432,3.60600438e-13 13.0712,3.60600438e-13 13.5008,3.60600438e-13 C13.9296,3.60600438e-13 13.92,0.3328 13.92,0.3328 C13.92,1.7424 13.92,5.4312 13.92,7.3264 C13.92,7.9408 13.92,8.3392 13.92,8.3392 C13.92,8.3392 15.3936,8.3392 16.3184,8.3392 C17.2416,8.3392 16.5464,9.0328 16.5464,9.0328 C16.5464,9.0328 12.6232,14.2408 12.076,14.7872 C11.6824,15.1832 11.3048,14.7408 11.3048,14.7408 Z",
    id: "Path"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.33fdeb4d7072f7f2fe595f93ead485bd.svg";
export { ForwardRef as ReactComponent };